import { RouteConfig } from 'vue-router';

import Audits from './pages/Audits.vue';
import Audit from './pages/Audit.vue';
import AuditGeneral from './pages/General.vue';
import AuditQuestions from './pages/Questions.vue';
import AuditPlan from './pages/Plan.vue';
import AuditCalendar from './pages/Calendar.vue';
import Workplaces from './pages/Workplaces.vue';
import FaultTypes from './pages/FaultTypes.vue';
import ShiftTypes from './pages/ShiftTypes.vue';
import IssueEscalationGroups from './pages/IssueEscalationGroups.vue';
import FindingEscalationGroups from './pages/FindingEscalationGroups.vue';
import MeasureImplementationEscalationGroups from './pages/MeasureImplementationEscalationGroups.vue';
import MeasureVerificationEscalationGroups from './pages/MeasureVerificationEscalationGroups.vue';
import { PermissionTypeEnum } from '../Api';

export default [
    {
        path: '/:tenantId/audits',
        name: 'Audits',
        component: Audits,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [
                PermissionTypeEnum.Audits,
                PermissionTypeEnum.EditAllAudits,
                PermissionTypeEnum.EditOwnedAudit,
                PermissionTypeEnum.PerformAudit,
            ],
            checkLicence: true,
            title: 'menu.audit',
        },
    },
    {
        path: '/:tenantId/audits/:auditId',
        name: 'Audit',
        component: Audit,
        props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
        children: [
            {
                path: '/:tenantId/audits/:auditId/general',
                name: 'AuditGeneral',
                component: AuditGeneral,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/questions',
                name: 'AuditQuestions',
                component: AuditQuestions,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/plan',
                name: 'AuditPlan',
                component: AuditPlan,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/workplaces',
                name: 'AuditWorkplaces',
                component: Workplaces,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/shift-types',
                name: 'AuditShiftTypes',
                component: ShiftTypes,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/fault-types',
                name: 'AuditFaultTypes',
                component: FaultTypes,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/issue-escalation-groups',
                name: 'AuditIssueEscalationGroups',
                component: IssueEscalationGroups,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/finding-escalation-groups',
                name: 'AuditFindingEscalationGroups',
                component: FindingEscalationGroups,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/measure-implementation-escalation-groups',
                name: 'AuditMeasureImplementationEscalationGroups',
                component: MeasureImplementationEscalationGroups,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/measure-verification-escalation-groups',
                name: 'AuditMeasureVerificationEscalationGroups',
                component: MeasureVerificationEscalationGroups,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
            {
                path: '/:tenantId/audits/:auditId/calendar',
                name: 'AuditCalendar',
                component: AuditCalendar,
                props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
                meta: {
                    permissions: [
                        PermissionTypeEnum.Audits,
                        PermissionTypeEnum.EditAllAudits,
                        PermissionTypeEnum.EditOwnedAudit,
                    ],
                    checkLicence: true,
                    title: 'menu.audit',
                },
            },
        ],
    },
] as RouteConfig[];
